import React from "react";
import "../styles/phone-mockup.css";
import { Link } from "react-router-dom";

export default function PhoneMockup({ src = "videos/app-demo.mp4" }) {
  return (
    <section className="pmk-section">
      <div className="pmk-wrapper">

        {/* TEXTO ARRIBA */}
        <div className="pmk-top">
          <h2 className="pmk-title">Así funciona</h2>
        </div>

        {/* VIDEO CENTRO + BOTONES DERECHA */}
        <div className="pmk-content">
          
          {/* CENTRO */}
          <div className="pmk-center">
            <div className="pmk-right">
              <div className="pmk-bg-circle"></div>

              <div className="pmk-phone">
                <div className="pmk-notch" />
                <div className="pmk-screen">
                  <video
                    className="pmk-video"
                    src={src}
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                </div>
              </div>
            </div>
          </div>

          {/* DERECHA */}
          <div className="pmk-actions">
            <Link to="/crear-cuenta" state={{ from: "servicios" }} className="btn pmk-btn">
              Suscribirse
            </Link>

            <Link to="/login" state={{ from: "servicios" }} className="btn secondary pmk-btn">
              Iniciar sesión
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}